var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MemberForm',{staticClass:"my-4",attrs:{"fromSection":"clientTeam","member":_vm.dataMember},on:{"sendData":function($event){return _vm.updateDataMember($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }